import { fetch as pltFetch, loadLoginCurrent, PltUser } from "@szgc/plt-core-v2";
import kinggrid from "../kinggrid";
import qs from "qs";

export interface KinggridSigItem {
  /**
   * 签章名
   */
  signname: string;
  /**
   * 签章图片后缀
   */
  imgext: string;
  /**
   * 签章base64编码图片
   */
  imgdata: string;
  /**
   * 签章宽度，数字字符串。ex：'0'
   */
  width: string;
  /**
   * 签章高度，数字字符串。ex：'0'
   */
  height: string;
  /**
   * imgtag
   */
  imgtag: string;
  /**
   * 签章序列号
   */
  signsn: string;
}

export interface KinggridSignListApiResult {
  /**
   * 请求时间，ex：4/25/22 4:30 PM
   */
  ServerTime: string;
  /**
   * 用户序列号
   */
  keysn: string;
  /**
   * 组织机构名称
   */
  orgname: string;
  /**
   * 用户电话
   */
  phone: string;
  /**
   * 请求结果
   */
  result: boolean;
  /**
   * 用户名
   */
  username: string;
  seals: Array<KinggridSigItem>;
}

/**
 * 文件字段 数据类型
 */
export const FILE_PROPERTY_TYPE = "view-png";

/**
 * 人员字段 数据类型
 */
export const USER_PROPERTY_TYPE = "user";

/**
 * 文件签章字段 数据类型
 */
export const FILE_STAMP_PROPERTY_TYPE = "file_stamp";

export function createFileSignatureInfo(): App.WebForm.FileSignatureInfo {
  return {
    opId: "",
    propertyName: "",
    /**
     * 签章名
     */
    signName: "",
    /**
     * 签章图片后缀
     */
    imgExt: "",
    /**
     * 签章base64编码图片
     */
    imgData: "",
    /**
     * 签章宽度，数字字符串。ex：'0'
     */
    width: "",
    /**
     * 签章高度，数字字符串。ex：'0'
     */
    height: "",
    /**
     * imgtag
     */
    imgTag: "",
    /**
     * 用户key序列号
     */
    keySn: "",
    /**
     * 签章序列号
     */
    signSn: "",
    /**
     * 经过sha256加密后的签章密码
     */
    password: "",
    /**
     * 页码
     */
    page: 0,
    /**
     * 文件页原始宽度
     */
    pageWidth: 0,
    /**
     * 文件页原始高度
     */
    pageHeight: 0,
    /**
     * 签章x坐标占比，0~1
     */
    x: 0,
    /**
     * 签章y坐标占比，0~1
     */
    y: 0,
    /**
     * 签章时间 时间戳
     */
    signTime: 0,
    /**
     * 签章流程任务节点 对应utKey
     */
    signTask: ""
  };
}

/**
 * 获取金格签章数据
 * @param url 服务地址
 * @param keysn
 * @returns
 */
export function get_kinggrid_sign_list(keysn?: string): Promise<{
  success: boolean;
  message: string;
  data: any;
}> {
  return new Promise((resolve) => {
    if (keysn) {
      const api = kinggrid.config.HTML5Url + "/html5?action=rest_key_load";

      pltFetch
        .post(api, {
          data: qs.stringify({ keysn: keysn }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then((res: any) => {
          const result = res as KinggridSignListApiResult;
          if (!result.result) {
            resolve({
              success: false,
              message: "获取签章列表失败",
              data: null
            });
          } else {
            resolve({
              success: true,
              message: "",
              data: result
            });
          }
        })
        .catch((e) => {
          console.log(e);
          resolve({
            success: false,
            message: "获取签章列表失败",
            data: null
          });
        });
    } else {
      loadLoginCurrent()
        .then((res) => {
          if (!res.success) {
            resolve({
              success: false,
              message: "读取用户keysn失败",
              data: null
            });
          } else {
            const current = res.data as PltUser;

            const api = kinggrid.config.HTML5Url + "/html5?action=rest_key_load";

            pltFetch
              .post(api, {
                data: qs.stringify({ keysn: current.username }),
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              })
              .then((res: any) => {
                const result = res as KinggridSignListApiResult;
                if (!result.result) {
                  resolve({
                    success: false,
                    message: "获取签章列表失败",
                    data: null
                  });
                } else {
                  resolve({
                    success: true,
                    message: "",
                    data: result
                  });
                }
              })
              .catch((e) => {
                console.log(e);
                resolve({
                  success: false,
                  message: "获取签章列表失败",
                  data: null
                });
              });
          }
        })
        .catch((e) => {
          console.log(e);
          resolve({
            success: false,
            message: "读取用户keysn失败",
            data: null
          });
        });
    }
  });
}

/**
 * 校验密码是否正确
 * @param keysn
 * @param password
 */
export async function verify_kg_pwd(keysn: string, password: string): Promise<boolean> {
  const api = kinggrid.config.HTML5Url + "/html5?action=rest_key_verify";
  const result = (await pltFetch.post(api, {
    data: qs.stringify({ keysn, password }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })) as unknown as { result: boolean };
  return result.result;
}

